import { useEffect, useRef } from "react";
import { useTracking } from "@edreamsodigeo/frontend-core";

import type { UseTrackPriceEventProps } from "~/components/engage/EqualProminenceMobile/contract";
import { useIsMeta } from "~/clientState/providers/SessionScopeProvider/SessionScopeProvider";
import { useCheckIsSkyscanner } from "~/clientState/properties/SkyscannerPriceProperties";

const useTrackPriceEvent = ({
  isFlightSummary,
  nonDiscountedPrice,
}: UseTrackPriceEventProps): void => {
  const isMeta = useIsMeta();
  const { trackFireEvent } = useTracking();
  const hasTracked = useRef(false);
  const isSkyscanner = useCheckIsSkyscanner();

  useEffect(() => {
    if (
      !hasTracked.current &&
      isFlightSummary &&
      isSkyscanner &&
      isMeta &&
      nonDiscountedPrice &&
      nonDiscountedPrice.amount
    ) {
      hasTracked.current = true;
      trackFireEvent(
        "price_available",
        "product_total_price_dom",
        nonDiscountedPrice.amount.toString(),
      );
    }
  }, [
    isFlightSummary,
    isMeta,
    nonDiscountedPrice,
    trackFireEvent,
    isSkyscanner,
  ]);
};

export default useTrackPriceEvent;
